import { useReveal } from "@/hooks/useReveal";

const ITEMS = [
  {
    title: "Unrefined, not recoloured",
    text: "Cane juice evaporated without centrifuging. The molasses was never taken out, so it was never added back.",
  },
  {
    title: "Certified, not claimed",
    text: "Ecocert USDA and EU Organic. South Africa has no national organic regulation, so those seals are used as they are, with no equivalence procedure and no waiting period.",
  },
  {
    title: "Familiar to your customer already",
    text: "Shoppers who know demerara and muscovado recognise this product on sight. The category education is largely done.",
  },
];

export default function ShelfArgument() {
  const ref = useReveal<HTMLDivElement>();

  return (
    <section className="bg-cream py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div ref={ref} className="reveal max-w-[800px]">
          <h2 className="text-ink font-serif text-3xl md:text-4xl font-semibold">
            Look at your own sweetener shelf first
          </h2>
          <p className="mt-5 text-ink/70 text-[17px] md:text-lg leading-relaxed">
            We are not going to tell you what is on South African shelves — you
            know that better than we do. What we would ask you to check is
            this: how much of the unrefined sugar on that shelf is genuinely
            unrefined, and how much of it is refined white sugar with molasses
            added back. And of the genuinely unrefined lines, how many carry a
            valid USDA and EU organic certification rather than a claim. That
            gap is the whole proposition.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {ITEMS.map((item) => (
            <div
              key={item.title}
              className="bg-white rounded-lg p-7 border border-cream-dark/60"
            >
              <h3 className="text-ink font-serif text-lg font-semibold">
                {item.title}
              </h3>
              <p className="mt-3 text-ink/70 text-[17px] leading-relaxed">
                {item.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}